import React from 'react';
import { Routes as RouterRoutes, Route, Navigate } from 'react-router-dom';
import { APP_PREFIX_PATH } from 'configs/AppConfig';
import { protectedRoutes, publicRoutes } from 'configs/RoutesConfig';
import ProtectedRoute from './ProtectedRoute';
import PublicRoute from './PublicRoute';
import AppRoute from './AppRoute';

const Routes = () => {
	const user = JSON.parse(localStorage.getItem("user"));
	let redireccionar = `${APP_PREFIX_PATH}/roles`; // fallback por si falla
	let newProtectedRoutes = [];
	if (user && protectedRoutes.length > 0) {
		// Encuentra la primera ruta a la que el usuario tiene permiso
		const rutaPermitida = protectedRoutes.find(route =>
			user.role.modulepermissions?.[route.key]
		);
		if (rutaPermitida) {
			
			redireccionar = `${rutaPermitida.path}`;			
		}

		newProtectedRoutes = protectedRoutes.filter(element => 
			user.role.modulepermissions[element.key]
		);

	}




	return (
		<RouterRoutes>
			{/* Rutas protegidas */}
			<Route path="/" element={<ProtectedRoute />}>
				<Route path="/" element={<Navigate replace to={redireccionar} />} />
				{newProtectedRoutes.map((route, index) => (
					<Route
						key={route.key + index}
						path={route.path}
						element={
							<AppRoute
								routeKey={route.key}
								component={route.component}
								{...route.meta}
							/>
						}
					/>
				))}
				<Route path="*" element={<Navigate to="/" replace />} />
			</Route>

			{/* Rutas públicas */}
			<Route path="/" element={<PublicRoute redireccionar={redireccionar} />}>
				{publicRoutes.map(route => (
					<Route
						key={route.path}
						path={route.path}
						element={
							<AppRoute
								routeKey={route.key}
								component={route.component}
								{...route.meta}
							/>
						}
					/>
				))}
			</Route>
		</RouterRoutes>
	);
};

export default Routes;
